import { StyleSheet, View } from 'react-native'
import Skeleton, { type ICustomViewStyle } from 'react-native-reanimated-skeleton'

import { DS } from '../../design-system'
import { getDSColorWithOpacity } from '../../design-system/Palette'

/** Enough rows to fill a phone screen below the header, so nothing pops in underneath. */
const ROW_KEYS = ['row-1', 'row-2', 'row-3', 'row-4', 'row-5', 'row-6']

/**
 * Mirrors ArticleRow's geometry (96px thumbnail, category, two title lines,
 * excerpt, meta) so the list does not jump when the feed arrives.
 */
const ROW_LAYOUT: ICustomViewStyle[] = [
  {
    key: 'row',
    flexDirection: 'row',
    gap: DS.spacing[16],
    children: [
      { key: 'thumbnail', width: 96, height: 96, borderRadius: DS.spacing[6] },
      {
        key: 'content',
        flex: 1,
        gap: DS.spacing[8],
        justifyContent: 'center',
        children: [
          { key: 'category', width: 64, height: 10 },
          { key: 'title-1', width: '100%', height: 14 },
          { key: 'title-2', width: '70%', height: 14 },
          { key: 'excerpt', width: '90%', height: 10 },
          { key: 'meta', width: 110, height: 10 }
        ]
      }
    ]
  }
]

const ArticleRowSkeleton = () => (
  <View style={styles.container}>
    <Skeleton
      isLoading
      layout={ROW_LAYOUT}
      containerStyle={styles.skeleton}
      boneColor={DS.palette['Brand/Light Grey']}
      highlightColor={getDSColorWithOpacity('Global/White', 0.5)}
    />
  </View>
)

export const ArticleListSkeleton = () => (
  <View style={styles.list} accessibilityLabel="Loading articles" accessibilityRole="progressbar">
    {ROW_KEYS.map((key) => (
      <ArticleRowSkeleton key={key} />
    ))}
  </View>
)

const styles = StyleSheet.create({
  list: {
    gap: DS.spacing[16]
  },
  container: {
    backgroundColor: DS.palette['Global/White'],
    borderRadius: DS.spacing[8],
    overflow: 'hidden',
    padding: DS.spacing[12]
  },
  // The library centres its container by default, which shrink-wraps the row
  // around its fixed-width bones and floats it in the middle of the card.
  skeleton: {
    alignItems: 'stretch'
  }
})
